import React, { forwardRef, useImperativeHandle, useRef } from 'react';

import { Frame, useEditor } from '@craftjs/core';

const EmailEditorGetHtml = ({ editorData }, ref) => {
  const htmlElRef = useRef(null);

  const { actions } = useEditor();

  const getHtml = () => {
    const json = editorData;

    !!json && actions.deserialize(json);

    const el = htmlElRef?.current;
    const html = el?.innerHTML;
    return html;
  };

  useImperativeHandle(ref, () => {
    return {
      getHtml,
    };
  });

  return (
    <div ref={htmlElRef} style={{ display: 'none' }}>
      <Frame></Frame>
    </div>
  );
};

export default forwardRef(EmailEditorGetHtml);
